let geoInstance;
export function init(cb) {
  Promise.all([loadScript('/libs/uni.webview.1.5.5.js'),loadScript('/libs/jweixin-1.3.2.js')])
  .then(() => {
    cb && cb();
  });
}

function loadScript(src, async = true) {
  const $script = document.createElement('script');
  $script.async = async;
  $script.src = src;
  document.body.appendChild($script);
  return new Promise((resolve, reject) => {
    $script.onload = () => {
      resolve(true);
    };
  });
}

export function scanCode(callBack) {
  buildPost('scanCode', callBack);
}


function getUrlParams(url) {
  const searchParams = new URLSearchParams(url.split('?')[1]);
  const params = {};

  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }

  return params;
}
export function getLocation(callBack) {
  let route = getUrlParams(location.href);
  let loca = JSON.parse(route.location||'{}');
  callBack && callBack({
    success:true,
    data:loca,
  });
  // wx.getLocation({
  //   success: callBack,
  // })
  //
  // var name = 'getGPSBack' + new Date().getTime();
  // callBack =
  //   typeof callBack === 'function'
  //     ? callBack
  //     : function (res) {
  //       console.log(res);
  //     };
  // var callParams = {};
  // callParams.data = '';
  // const cb = function (appData) {
  //   appData = appData ? JSON.parse(appData) : {};
  //   if (typeof appData.code === 'undefined' || appData.code != 0 || Object.keys(appData.data).length <= 0) {
  //     callParams.success = false;
  //     callParams.msg = appData.msg || '无法获取错误信息';
  //     callBack(callParams);
  //     return;
  //   }
  //   callParams.success = true;
  //   callParams.data = appData.data || {};
  //   callParams.msg = appData.msg;
  //   callBack(callParams);
  // };
  //
  // postMsg('getGPS', name, window.currentFrameIndex, cb);
}

export function share(data, callBack) {
  wx.miniProgram.navigateTo({ url: '/pages/toShare/toShare?data='+JSON.stringify(data) });
}

export function setClipboardData(data, callBack) {
  buildPost('setClipboardData', callBack, null,{data});
}

export function openDocument(data, callBack) {
  // 通过 postMessage 让小程序下载并打开文档
  buildPost('openDocument', callBack, null, data);
}

export function chooseMap(callBack) {
  wx.miniProgram.navigateTo({ url: '/pages/chooseMap/chooseMap' });
}

export function openLocation(data, callBack) {

  wx.miniProgram.navigateTo({ url: '/pages/openLocation/openLocation?data='+JSON.stringify({
      name:data.sellerName,
      latitude: data.dLat, // 纬度，浮点数，范围为90 ~ -90
      longitude: data.dLng, // 经度，浮点数，范围为180 ~ -180。
    }) });
  // buildPost('openLocation', callBack,null,data);

}
export function login(callBack) {
  buildPost('login', callBack);
}

function buildPost(name, callBack, customCB, data) {
  var cbName = name + new Date().getTime();
  callBack =
    typeof callBack === 'function'
      ? callBack
      : function (res) {
        console.log(res);
      };
  var callParams = {};
  callParams.data = '';
  const cb = function (appData) {
    appData = appData ? JSON.parse(appData) : {};
    if (typeof appData.code === 'undefined' || appData.code != 0) {
      callParams.success = false;
      callParams.msg = appData.msg || '无法获取错误信息';
      callBack(callParams);
      return;
    }
    callParams.success = true;
    callParams.data = appData.data || {};
    callParams.msg = appData.msg;
    callBack(callParams);
  };

  postMsg(name, cbName, window.currentFrameIndex, customCB || cb, data);
}

function postMsg(type, name, index, cb, data) {
  wx.miniProgram.postMessage({
    data: {
      action: type,
      cb: name,
      data,
      index,
    },
  });
  wx.miniProgram.navigateBack({ delta: 0 })
  if (index || index === 0) {
    window.parent.frames[index][name] = function (res) {
      // console.log(res)
      cb && cb(decodeURIComponent(res));
    };
  } else {
    window[name] = function (res) {
      // console.log(res)
      cb && cb(decodeURIComponent(res));
    };
  }
}
